import { render, staticRenderFns } from "./LevelDescriptionsModal.vue?vue&type=template&id=b95afe7a&scoped=true"
import script from "./LevelDescriptionsModal.vue?vue&type=script&lang=js"
export * from "./LevelDescriptionsModal.vue?vue&type=script&lang=js"
import style0 from "./LevelDescriptionsModal.vue?vue&type=style&index=0&id=b95afe7a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95afe7a",
  null
  
)

export default component.exports